import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { editSection, getAllPageSections, getSection } from "store/actions";

import Table from "./Table";
import { Col, Row } from "react-bootstrap";
import { Input } from "components/shared/FormComponents";
import { useForm } from "react-hook-form";
import SaveChangesButton from "components/shared/SaveChangesButton";
import Loader from "components/shared/Loader";

const AdvirtiseType = () => {
  const dispatch = useDispatch();
  const { sections, section, loading, error } = useSelector(
    (state) => state.section
  );

  const { formatMessage, locale } = useIntl();
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();
  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    dispatch(
      editSection({
        slug: "contact",
        page: "home",
        data: { section: data },
      })
    );
  };
  useEffect(() => {
    dispatch(getAllPageSections("contact"));
    dispatch(
      getSection({
        page: "home",
        slug: "contact",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset({
      heading: section?.heading,
    });
  }, [reset, section]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="property-wrap">
      <div className="card">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col lg={6} xs={12}>
              <Input
                langId="title"
                name="heading.ar"
                register={register}
                errors={errors}
              />
            </Col>
            <Col lg={6} xs={12}>
              <Input
                langId="title"
                name="heading.en"
                register={register}
                errors={errors}
                dir="ltr"
              />
            </Col>
          </Row>
          <SaveChangesButton />
        </form>
      </div>

      <Table data={sections} loading={false} />
    </div>
  );
};

export default AdvirtiseType;
